import { faScroll } from "@fortawesome/free-solid-svg-icons";
import { ExportRelatorioControleManutencaoController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/RelatorioControle/RelatorioControleManutencaoControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IRelatorioControleManutecaoRequest } from "../../../../Services/AssistenciaTecnica/Atendimento/RelatorioControle/RelatorioControleManutencaoServices";

import { saveAs } from "file-saver";
import IconOrSpinner from "../../../../Components/Utils/IconOrSpinner";

interface IButtonRelatorioManutencaoProps
    extends IRelatorioControleManutecaoRequest {}

export default function ButtonRelatorioManutencao(
    props: IButtonRelatorioManutencaoProps
) {
    const { execute, loading } = useAsyncCallback(
        () => ExportRelatorioControleManutencaoController(props),
        [props]
    );

    return (
        <button
            type="button"
            className="btn btn-sm d-flex align-items-center g-2 btn-shadow btn-info m-1"
            disabled={loading}
            onClick={async () => {
                const excelControleManutencao = await execute();
                saveAs(
                    excelControleManutencao,
                    `RELATORIO_CONTROLE_DE_MANUTENCAO_CASO_${props.ID_CASO}.pdf`
                );
            }}
        >
            <IconOrSpinner icon={faScroll} loading={loading} loadingSize="sm" />
            Relatório de Controle de Reparo
        </button>
    );
}
